/**
 * NFC deep links for Android app. When the web app runs inside the Android WebView,
 * these URLs are intercepted and open native NFC activities (write, erase, logs, device status).
 * On desktop they are no-ops (or open a hint to use the Android app).
 */

const ANDROID_WEBVIEW_UA = /Android|wv\)/.test(navigator.userAgent);

export function isAndroidApp(): boolean {
  return ANDROID_WEBVIEW_UA;
}

/** Open native NFC bulk-write flow (Android app only). Pass url and optional memberId so the app can commit the write to the backend. */
export function openNfcWrite(url?: string, memberId?: string): void {
  if (isAndroidApp()) {
    const u = url ? encodeURIComponent(url) : "";
    const m = memberId ? encodeURIComponent(memberId) : "";
    const params = [u ? `url=${u}` : "", m ? `memberId=${m}` : ""].filter(Boolean).join("&");
    window.location.href = params ? `scja://nfc/write?${params}` : "scja://nfc/write";
  }
}

/** Open native NFC bulk-erase flow (Android app only). */
export function openNfcErase(): void {
  if (isAndroidApp()) window.location.href = "scja://nfc/erase";
}

/** Open native NFC logs screen (Android app only). */
export function openNfcLogs(): void {
  if (isAndroidApp()) window.location.href = "scja://nfc/logs";
}

/** Open native device status screen (Android app only). */
export function openNfcDeviceStatus(): void {
  if (isAndroidApp()) window.location.href = "scja://nfc/device-status";
}
